export class RegisterInfo {

  applicationCode: string;
  email: string;
  password: string;
  confirmPassword: string;
  auctionClusterId: number;

  constructor(applicationCode?: string) {
    this.applicationCode = applicationCode;
  }
}
